<template>
    <div class="container reporte-ori-container">
        <b-row>
            <b-container>
                <h3 class="text-center py-2">
                    <b><i>REPORTES ORI</i></b>
                </h3>

                <h5 class="text-center py-2">
                    <!-- FILTROS -->
                    <b-row class="mb-4 justify-content-center align-items-end text-lg">
                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">Reporte:</label>
                            <select v-model="selReporte" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="reporte in listReporte" :key="reporte.id" :value="reporte.codigo">
                                    {{ reporte.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Vigencia:
                            </label>
                            <select v-model="selVigencia" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 200px;">
                                <option value="">Seleccione...</option>
                                <option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
                                    {{ vigencia.vigencia }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Grupo:
                            </label>
                            <select v-model="grupoId" @change="f_filterCompany"
                                class="form-control form-control-lg w-auto mx-auto fs-5" style="min-width: 200px;">
                                <option value="">Todos los grupos</option>
                                <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                                    {{ grupo.nombre }}
                                </option>
                            </select>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <label class="filtro-label">
                                Compañía:
                            </label>
                            <select v-model="companyId" class="form-control form-control-lg w-auto mx-auto fs-5"
                                style="min-width: 180px; max-width: 250px;">
                                <option value="">Seleccione...</option>
                                <option v-for="company in filteredCompany" :key="company.id" :value="company.id">
                                    {{ company.acronym + " - " + company.nombre }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- CHECKBOXES -->
                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Balance" v-model="mostrarBalance" class="mr-1">
                            <label for="Balance" class="checkbox-label">Balance</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Reporte" v-model="mostrarReporte" class="mr-1">
                            <label for="Reporte" class="checkbox-label">Reporte</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Informacion" v-model="mostrarInformacion" class="mr-1">
                            <label for="Informacion" class="checkbox-label">Información</label>
                        </b-col>

                        <b-col md="auto" class="text-center px-3">
                            <input type="checkbox" id="Consolidado" v-model="mostrarConsolidado"
                                @change="handleConsolidadoChange" class="mr-1">
                            <label for="Consolidado" class="checkbox-label">Consolidado</label>
                        </b-col>
                    </b-row>

                    <!-- BOTÓN -->
                    <b-row class="mb-4 justify-content-center align-items-center">
                        <b-col md="auto" class="text-center">
                            <b-button variant="primary" @click="consultarDatos" class="btn-lg px-5 mx-2 fs-5">
                                <b><i>Generar</i></b>
                            </b-button>
                        </b-col>
                    </b-row>

                    <!-- EMPRESAS CONSOLIDADO -->
                    <b-row v-if="mostrarConsolidado && mostrarEmpresas" class="mt-4">
                        <b-col md="12">
                            <div class="consolidation-section p-4 border rounded bg-light">
                                <label class="d-block fw-bold fs-5 mb-3 text-center">
                                    <b>Empresas para consolidar:</b>
                                </label>

                                <div class="mb-3 text-center">
                                    <b-form-checkbox v-model="selectAllCompanies" @change="toggleAllCompanies"
                                        class="fw-bold fs-6">
                                        {{ selectAllCompanies
                                            ? 'Deseleccionar todas'
                                            : 'Seleccionar todas' }}
                                    </b-form-checkbox>
                                </div>

                                <div class="companies-checkbox-list"
                                    style="max-height: 300px; overflow-y: auto; border: 1px solid #ccc; padding: 15px; border-radius: 5px; background-color: white;">
                                    <b-form-checkbox-group v-model="empresasSeleccionadas" stacked
                                        class="checkbox-group">
                                        <b-form-checkbox v-for="company in listEmpresasDisponibles" :key="company.id"
                                            :value="company.id" class="company-checkbox">
                                            {{ company.acronym ? company.acronym + ' - ' : '' }}{{ company.nombre }}
                                        </b-form-checkbox>
                                    </b-form-checkbox-group>
                                </div>

                                <div class="text-center mt-3">
                                    <b-button variant="outline-secondary" @click="mostrarEmpresas = false"
                                        class="btn-sm">
                                        Ocultar selección
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </h5>
            </b-container>
        </b-row>

        <!-- LOADING -->
        <b-row>
            <b-container v-if="isLoading" class="pb-5" style="min-height: 400px;">
                <div class="text-center py-5">
                    <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                    <h4 class="text-primary mt-3">
                        <b><i>Cargando información...</i></b>
                    </h4>
                </div>
            </b-container>

            <!-- INFORMACIÓN - Tabla de Valores Manuales -->
            <b-container v-if="!isLoading && datosConsultados && mostrarInformacion && listFilasManuales.length > 0"
                class="pb-5">
                <md-table v-model="listFilasManuales" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>Información Manual - Valores a Ingresar</i></b>
                                </h1>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="abrirModalValor(item)"
                        style="cursor: pointer;">
                        <md-table-cell md-label="Descripción" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell md-label="Valor" class="text-right number-cell">
                            {{
                                item.valorGuardado !== null &&
                                    item.valorGuardado !== undefined
                                    ? formatCurrency(item.valorGuardado)
                                    : '$ 0'
                            }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- BALANCE -->
            <b-container v-if="!isLoading && datosConsultados && mostrarBalance && listReportesGuardados.length > 0 && tieneDatosValidos()" class="pb-5">
                <md-table v-model="listReportesGuardados" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTabla }}</i></b>
                                </h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listReportesGuardados.length > 0" @click="exportarExcel"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell md-label="Local" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_local) }}
                        </md-table-cell>
                        <md-table-cell md-label="Funcional" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_funcional) }}
                        </md-table-cell>
                        <md-table-cell md-label="Interna" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_interna) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- REPORTE COMPARATIVO -->
            <b-container v-if="!isLoading && datosConsultados && mostrarReporte && listReportesComparativo.length > 0" class="pb-5">
                <md-table v-model="listReportesComparativo" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTablaReporte }}</i></b>
                                </h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listReportesComparativo.length > 0" @click="exportarExcelReporte"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell :md-label="vigenciaActual" class="text-right number-cell">
                            {{ formatCurrency(item.saldo_actual) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- CONSOLIDADO -->
            <b-container v-if="!isLoading && datosConsultados && mostrarConsolidado && listConsolidado.length > 0" class="pb-5">
                <md-table v-model="listConsolidado" md-card md-fixed-header class="balance-table principal-table">
                    <md-table-toolbar>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <div style="flex: 1; text-align: center;">
                                <h1 class="md-title">
                                    <b><i>{{ tituloTablaConsolidado }}</i></b>
                                </h1>
                            </div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <md-button v-if="listConsolidado.length > 0" @click="exportarExcelConsolidado"
                                    class="md-fab md-primary">
                                    <md-icon>description</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Descripción / NIIF (IFRS)" class="text-left descripcion-cell">
                            {{ item.descripcion || '-' }}
                        </md-table-cell>
                        <md-table-cell md-label="Funcional" class="text-right number-cell">
                            {{ formatCurrency(item.total_sin_ajustes) }}
                        </md-table-cell>
                        <md-table-cell md-label="Ajustes" class="text-right number-cell">
                            {{ formatCurrency(item.total_ajustes) }}
                        </md-table-cell>
                        <md-table-cell md-label="Consolidado" class="text-right number-cell">
                            {{ formatCurrency(item.total_consolidado) }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </b-container>

            <!-- MENSAJE SIN INFORMACIÓN -->
            <b-container v-if="!isLoading && datosConsultados && !tieneAlgunDatoValido()">
                <b-col md="2" class="mx-auto">
                    <div class="success-svg mb-4" :class="{ active: true }">
                        <img src="../../assets/imgs/file-2.svg" alt="warning" />
                    </div>
                </b-col>
                <b-col md="12" class="justify-content-around">
                    <span id="message">Sin Información</span>
                </b-col>
            </b-container>
        </b-row>

        <!-- MODAL PARA INGRESAR VALOR MANUAL -->
        <md-dialog :md-active.sync="showModalValor" class="valor-dialog">
            <md-dialog-title class="dialog-header-create">
                Ingresar Valor Manual
            </md-dialog-title>

            <md-dialog-content>
                <div class="form-container">
                    <div class="form-group">
                        <label class="field-label">Descripción</label>
                        <md-field>
                            <md-input :value="filaSeleccionada ? filaSeleccionada.descripcion : ''" disabled></md-input>
                        </md-field>
                    </div>

                    <div class="form-group">
                        <label class="field-label required">Valor</label>
                        <md-field>
                            <md-input v-model="valorIngresado" type="number" step="0.01" placeholder="Ingrese el valor"
                                @keyup.enter="guardarValorManual">
                            </md-input>
                        </md-field>
                    </div>
                </div>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-raised" @click="cerrarModalValor">Cancelar</md-button>
                <md-button class="md-raised md-primary" @click="guardarValorManual"
                    :disabled="valorIngresado === null || valorIngresado === ''">
                    Guardar
                </md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import Company from "../../services/Company"
import PlanCuentas from "../../services/PlanCuentas"
import TipoReporte from '../../services/TipoReporte';
import Grupo from "../../services/Grupo";
import Balance from "../../services/BalanceNiif";
import * as XLSX from "exceljs";

export default {
    name: "ReporteORI",
    data: () => ({
        selReporte: "",
        selVigencia: "",
        grupoId: "",
        companyId: "",
        listReporte: [],
        listVigencia: [],
        listGrupos: [],
        listCompany: [],
        filteredCompany: [],
        listReportesGuardados: [],
        isLoading: false,
        datosConsultados: false,
        monedaFuncional: "COP",
        monedaInterna: "USD",
        mostrarBalance: false,
        mostrarReporte: false,
        mostrarInformacion: false,
        listReportesComparativo: [],
        vigenciaActual: '',
        vigenciaAnterior: '',
        listFilasManuales: [],
        // Modal
        showModalValor: false,
        filaSeleccionada: null,
        valorIngresado: null,
        mostrarConsolidado: false,
        mostrarEmpresas: false,
        empresasSeleccionadas: [],
        listEmpresasDisponibles: [],
        selectAllCompanies: false,
        listConsolidado: [],
    }),

    watch: {
        mostrarBalance(newVal) {
            if (newVal) {
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
            }
        },
        mostrarReporte(newVal) {
            if (newVal) {
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
            }
        },
        mostrarInformacion(newVal) {
            if (newVal) {
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarConsolidado) this.mostrarConsolidado = false;
            }
        },
        grupoId() {
            this.filtrarEmpresasPorGrupo();
            this.empresasSeleccionadas = [];
        },
        mostrarConsolidado(newVal) {
            if (newVal) {
                if (this.mostrarBalance) this.mostrarBalance = false;
                if (this.mostrarReporte) this.mostrarReporte = false;
                if (this.mostrarInformacion) this.mostrarInformacion = false;
                this.companyId = '';
                this.mostrarEmpresas = true;
                this.filtrarEmpresasPorGrupo();
            } else {
                this.mostrarEmpresas = false;
                this.empresasSeleccionadas = [];
                this.listConsolidado = [];
                this.datosConsultados = false;
            }
        },
        listEmpresasDisponibles: {
            handler(newVal) {
                if (newVal.length === 0) {
                    this.selectAllCompanies = false;
                }
            },
            deep: true
        },
        empresasSeleccionadas: {
            handler(newVal) {
                if (this.listEmpresasDisponibles.length > 0) {
                    this.selectAllCompanies = newVal.length === this.listEmpresasDisponibles.length;
                }
            },
            deep: true
        }

    },

    computed: {
        tituloTabla() {
            return "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
        },
        tituloTablaReporte() {
            if (this.companyId && this.selVigencia) {
                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? `${company.acronym} - ${company.nombre}` : this.companyId;
                return `Reporte ORI Comparativo (${companyName}) ${this.vigenciaActual}`;
            }
            return "ORI - Reporte Comparativo";
        },
        tituloTablaConsolidado() {
            if (this.selVigencia) {
                return `Reporte ORI Consolidado ${this.selVigencia}`;
            }
            return "ORI - Reporte Consolidado";
        },
    },

    methods: {
        formatCurrency(value) {
            if (value === null || value === undefined) return '0';
            return new Intl.NumberFormat('es-CO', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value).replace(/\./g, ',');
        },

        async consultarDatos() {
            if (!this.selReporte || !this.selVigencia) {
                this.$toast.warning("Seleccione reporte y vigencia");
                return;
            }

            // Validación para Consolidado
            if (this.mostrarConsolidado) {
                if (!this.empresasSeleccionadas || this.empresasSeleccionadas.length === 0) {
                    this.$toast.warning("Seleccione al menos una empresa para consolidar");
                    return;
                }
            } else {
                if (!this.companyId) {
                    this.$toast.warning("Seleccione una compañía");
                    return;
                }
            }

            if (!this.mostrarBalance && !this.mostrarReporte && !this.mostrarInformacion && !this.mostrarConsolidado) {
                this.$toast.warning("Seleccione al menos una opción (Balance, Reporte, Información o Consolidado)");
                return;
            }

            this.isLoading = true;
            this.datosConsultados = true;

            try {
                this.listReportesGuardados = [];
                this.listReportesComparativo = [];
                this.listFilasManuales = [];
                this.listConsolidado = [];

                if (this.mostrarConsolidado) {
                    await this.cargarConsolidado();
                    this.mostrarEmpresas = false;

                    if (this.listConsolidado.length === 0) {
                        this.$toast.warning("No existe información consolidada para las empresas seleccionadas");
                    } else {
                        this.$toast.success("Reporte consolidado cargado correctamente");
                    }
                } else {
                    if (this.mostrarBalance) {
                        await this.cargarBalance();
                    }

                    if (this.mostrarReporte) {
                        await this.cargarReporteComparativo();
                    }

                    if (this.mostrarInformacion) {
                        await this.cargarFilasManuales();
                    }

                    if (this.mostrarBalance && this.mostrarReporte && this.mostrarInformacion) {
                        this.$toast.success("Balance, Reporte e Información cargados");
                    } else if (this.mostrarBalance && this.mostrarReporte) {
                        this.$toast.success("Balance y Reporte cargados");
                    } else if (this.mostrarBalance && this.mostrarInformacion) {
                        this.$toast.success("Balance e Información cargados");
                    } else if (this.mostrarReporte && this.mostrarInformacion) {
                        this.$toast.success("Reporte e Información cargados");
                    } else if (this.mostrarBalance) {
                        if (this.listReportesGuardados.length === 0 || !this.tieneDatosValidos()) {
                            this.$toast.warning("No existe información de Balance para esta compañía");
                        } else {
                            this.$toast.success("Balance cargado correctamente");
                        }
                    } else if (this.mostrarReporte) {
                        if (this.listReportesComparativo.length === 0) {
                            this.$toast.warning("No existe información de Reporte para esta compañía");
                        } else {
                            this.$toast.success("Reporte cargado correctamente");
                        }
                    } else if (this.mostrarInformacion) {
                        if (this.listFilasManuales.length === 0) {
                            this.$toast.warning("No existen filas de tipo Manual para esta configuración");
                        } else {
                            this.$toast.success("Información manual cargada correctamente");
                        }
                    }
                }

            } catch (error) {
                console.error("Error cargando datos:", error);
                this.$toast.error("Error al cargar los datos");
                if (this.mostrarConsolidado) {
                    this.mostrarEmpresas = false;
                }
            } finally {
                this.isLoading = false;
            }
        },

        async exportarExcelConsolidado() {
            if (!this.listConsolidado.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reporte ORI Consolidado");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';

                // Título principal
                worksheet.mergeCells('A1:D1');
                worksheet.getCell('A1').value = "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia
                worksheet.mergeCells('A2:D2');
                worksheet.getCell('A2').value = `Vigencia: ${this.selVigencia} | Consolidado de múltiples empresas`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells('A3:D3');
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                const headers = ['Descripción / NIIF (IFRS)', 'Funcional', 'Ajustes', 'Consolidado'];
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                worksheet.columns = [
                    { width: 50 },
                    { width: 25 },
                    { width: 25 },
                    { width: 25 }
                ];

                this.listConsolidado.forEach(item => {
                    const row = worksheet.addRow([
                        item.descripcion || '-',
                        item.total_sin_ajustes || 0,
                        item.total_ajustes || 0,
                        item.total_consolidado || 0
                    ]);
                    row.getCell(1).style = styles.datoNormal;
                    row.getCell(2).style = styles.datoNumero;
                    row.getCell(3).style = styles.datoNumero;
                    row.getCell(4).style = styles.datoNumero;
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_Consolidado_${this.selVigencia}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async cargarBalance() {
            try {
                const response = await Balance.obtenerFilasPrincipalesOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                let datos = response.data.data || [];

                // TRANSFORMAR los datos anidados
                if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
                    const primerElemento = datos[0];
                    const valores = Object.values(primerElemento);
                    datos = valores.filter(item => item && item.id);
                }

                // Si no hay datos, intentar copiar desde vigencia anterior
                if (datos.length === 0) {
                    const añoActual = parseInt(this.selVigencia.substring(0, 4));
                    const mes = this.selVigencia.substring(4, 6);
                    const vigenciaAnterior = `${añoActual - 1}${mes}`;

                    const userId = this.$store?.state?.userId || localStorage.getItem('userId');

                    await Balance.copiarConfiguracionOri(
                        this.selReporte,
                        this.companyId,
                        vigenciaAnterior,
                        this.selVigencia,
                        userId
                    );

                    // Volver a consultar después de copiar
                    const newResponse = await Balance.obtenerFilasPrincipalesOri(
                        this.selReporte,
                        this.companyId,
                        this.selVigencia
                    );

                    datos = newResponse.data.data || [];

                    if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
                        const primerElemento = datos[0];
                        const valores = Object.values(primerElemento);
                        datos = valores.filter(item => item && item.id);
                    }
                }

                if (datos.length === 0) {
                    this.listReportesGuardados = [];
                    return;
                }

                this.listReportesGuardados = datos.map(fila => ({
                    id: fila.id,
                    orden: fila.orden,
                    descripcion: fila.descripcion,
                    saldo_local: fila.total,
                    saldo_funcional: fila.total,
                    saldo_interna: fila.total
                }));

            } catch (error) {
                console.error("Error cargando Balance:", error);
                throw error;
            }
        },

        async cargarReporteComparativo() {
            try {
                const response = await Balance.obtenerReporteComparativoOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                if (response.data && response.data.data) {
                    // Usar los valores directamente sin modificar
                    this.listReportesComparativo = response.data.data;

                    if (response.data.vigencias) {
                        this.vigenciaActual = response.data.vigencias.actual;
                        this.vigenciaAnterior = response.data.vigencias.anterior;
                    }
                } else {
                    this.listReportesComparativo = [];
                }

            } catch (error) {
                console.error("Error cargando reporte comparativo:", error);
                this.listReportesComparativo = [];
                throw error;
            }
        },

        async cargarFilasManuales() {
            try {
                const response = await Balance.obtenerFilasPrincipalesOri(
                    this.selReporte,
                    this.companyId,
                    this.selVigencia
                );

                let filas = response.data.data || [];

                if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                    const primerElemento = filas[0];
                    const valores = Object.values(primerElemento);
                    filas = valores.filter(item => item && item.id);
                }

                // Si no hay datos, intentar copiar desde vigencia anterior
                if (filas.length === 0) {
                    const añoActual = parseInt(this.selVigencia.substring(0, 4));
                    const mes = this.selVigencia.substring(4, 6);
                    const vigenciaAnterior = `${añoActual - 1}${mes}`;

                    const userId = this.$store?.state?.userId || localStorage.getItem('userId');

                    await Balance.copiarConfiguracionOri(
                        this.selReporte,
                        this.companyId,
                        vigenciaAnterior,
                        this.selVigencia,
                        userId
                    );

                    // Volver a consultar después de copiar
                    const newResponse = await Balance.obtenerFilasPrincipalesOri(
                        this.selReporte,
                        this.companyId,
                        this.selVigencia
                    );

                    filas = newResponse.data.data || [];

                    if (filas.length > 0 && typeof filas[0] === 'object' && !Array.isArray(filas[0])) {
                        const primerElemento = filas[0];
                        const valores = Object.values(primerElemento);
                        filas = valores.filter(item => item && item.id);
                    }
                }

                if (filas.length === 0) {
                    this.listFilasManuales = [];
                    return;
                }

                const filasConFormulaciones = await Promise.all(
                    filas.map(async (filaItem) => {
                        const formulacionesResponse = await Balance.obtenerFormulacionesOri(
                            this.selReporte,
                            this.companyId,
                            this.selVigencia,
                            filaItem.orden
                        );

                        const formulaciones = formulacionesResponse.data.data || [];

                        console.log(`Formulaciones para orden ${filaItem.orden}:`, formulaciones);

                        const formulacionManual = formulaciones.find(f => f.formulacion === 'm');

                        if (formulacionManual) {
                            console.log(`Formulación manual encontrada:`, formulacionManual);
                            console.log(`Valor guardado: ${formulacionManual.valor}`);

                            return {
                                id: filaItem.id,
                                orden: filaItem.orden,
                                descripcion: filaItem.descripcion,
                                formulaciones: formulaciones,
                                formulacionId: formulacionManual.id,
                                valorGuardado: formulacionManual.valor !== null ? parseFloat(formulacionManual.valor) : 0
                            };
                        }
                        return null;
                    })
                );

                this.listFilasManuales = filasConFormulaciones.filter(filaItem => filaItem !== null);

                console.log('Filas manuales cargadas:', this.listFilasManuales);

            } catch (error) {
                console.error("Error cargando filas manuales:", error);
                this.listFilasManuales = [];
                throw error;
            }
        },

        abrirModalValor(fila) {
            this.filaSeleccionada = fila;
            this.valorIngresado = fila.valorGuardado !== null ? fila.valorGuardado : null;
            this.showModalValor = true;
        },

        cerrarModalValor() {
            this.showModalValor = false;
            this.filaSeleccionada = null;
            this.valorIngresado = null;
        },

        async guardarValorManual() {
            if (this.valorIngresado === null || this.valorIngresado === '') {
                this.$toast.warning("Ingrese un valor válido");
                return;
            }

            const userId = this.$store?.state?.userId || localStorage.getItem('userId');

            if (!userId) {
                this.$toast.error("No se encontró el ID de usuario");
                return;
            }

            this.isLoading = true;

            try {
                const payload = {
                    accion: this.filaSeleccionada.formulacionId ? 'UPDATE_FORMULACION' : 'INSERT_FORMULACION',
                    id: this.filaSeleccionada.formulacionId || null,
                    codReporte: parseInt(this.selReporte),
                    vigencia: this.selVigencia,
                    id_compania: parseInt(this.companyId),
                    orden: parseInt(this.filaSeleccionada.orden),
                    reporte: 'ORI',
                    niif: null,
                    cuentas: null,
                    contable: 0,
                    actual: 1,
                    operacion: '+',
                    formulacion: 'm',
                    valor: parseFloat(this.valorIngresado),
                    u_crea: parseInt(userId),
                    u_modifica: parseInt(userId)
                };

                await Balance.gestionarFormulacionesOri(payload);

                this.filaSeleccionada.valorGuardado = parseFloat(this.valorIngresado);
                this.filaSeleccionada.formulacionId = this.filaSeleccionada.formulacionId || (payload.id);

                this.$toast.success("Valor guardado correctamente");
                this.cerrarModalValor();

            } catch (error) {
                console.error("Error guardando valor:", error);
                this.$toast.error(error.response?.data?.message || "Error al guardar el valor");
            } finally {
                this.isLoading = false;
            }
        },

        tieneDatosValidos() {
            if (!this.listReportesGuardados || this.listReportesGuardados.length === 0) {
                return false;
            }

            return this.listReportesGuardados.some(item => {
                return (item.saldo_local && item.saldo_local !== 0) ||
                    (item.saldo_funcional && item.saldo_funcional !== 0) ||
                    (item.saldo_interna && item.saldo_interna !== 0) ||
                    (item.descripcion && item.descripcion.trim() !== '');
            });
        },

        tieneAlgunDatoValido() {
            if (this.mostrarBalance) {
                if (this.listReportesGuardados.length > 0 && this.tieneDatosValidos()) {
                    return true;
                }
            }

            if (this.mostrarReporte) {
                if (this.listReportesComparativo.length > 0) {
                    return true;
                }
            }

            if (this.mostrarInformacion) {
                if (this.listFilasManuales.length > 0) {
                    return true;
                }
            }

            if (this.mostrarConsolidado) {
                if (this.listConsolidado.length > 0) {
                    return true;
                }
            }

            return false;
        },

        f_filterCompany() {
            if (this.grupoId) {
                const grupoIdNum = this.grupoId.toString();
                this.filteredCompany = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false;
                    const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
                    return gruposCompania.includes(grupoIdNum);
                });
            } else {
                this.filteredCompany = this.listCompany;
            }
            this.companyId = "";
        },

        handleConsolidadoChange(checked) {
            if (checked) {
                this.filtrarEmpresasPorGrupo();
            } else {
                this.empresasSeleccionadas = [];
            }
        },

        filtrarEmpresasPorGrupo() {
            if (this.mostrarConsolidado) {
                if (this.grupoId && this.grupoId !== 'todos' && this.grupoId !== '') {
                    const grupoIdNum = this.grupoId.toString();
                    this.listEmpresasDisponibles = this.listCompany.filter(company => {
                        if (!company.id_grupos) return false;
                        const gruposCompania = company.id_grupos.split(',').map(id => id.trim());
                        return gruposCompania.includes(grupoIdNum);
                    });
                } else {
                    this.listEmpresasDisponibles = [...this.listCompany];
                }
                this.empresasSeleccionadas = [];
                this.selectAllCompanies = false;
            }
        },

        seleccionarTodasEmpresas() {
            this.empresasSeleccionadas = this.listEmpresasDisponibles.map(c => c.id);
        },

        async cargarConsolidado() {
            try {
                const empresasStr = this.empresasSeleccionadas.join(',');

                const response = await Balance.obtenerReporteConsolidadoOri(
                    this.selReporte,
                    empresasStr,
                    this.selVigencia
                );

                if (response.data && response.data.data) {
                    let datos = response.data.data;

                    if (datos.length > 0 && typeof datos[0] === 'object' && !Array.isArray(datos[0])) {
                        const keys = Object.keys(datos[0]);
                        if (keys.length > 0 && !isNaN(keys[0])) {
                            const valores = Object.values(datos[0]);
                            datos = valores.filter(item => item && item.id);
                        }
                    }

                    this.listConsolidado = datos.map(item => ({
                        id: item.id,
                        orden: item.orden,
                        descripcion: item.descripcion,
                        total_sin_ajustes: item.total_sin_ajustes || 0,
                        total_ajustes: item.total_ajustes || 0,
                        total_consolidado: item.total_consolidado || 0
                    }));
                } else {
                    this.listConsolidado = [];
                }
            } catch (error) {
                console.error("Error cargando consolidado:", error);
                this.listConsolidado = [];
                throw error;
            }
        },

        toggleAllCompanies() {
            if (this.selectAllCompanies) {
                this.empresasSeleccionadas = this.listEmpresasDisponibles.map(c => c.id);
            } else {
                this.empresasSeleccionadas = [];
            }
        },

        async exportarExcelReporte() {
            if (!this.listReportesComparativo.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reporte ORI");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? company.nombre : this.companyId;
                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';

                // Título principal
                worksheet.mergeCells('A1:B1');
                worksheet.getCell('A1').value = "ESTADOS DE OTROS RESULTADOS INTEGRALES - ORI";
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia y Compañía
                worksheet.mergeCells('A2:B2');
                worksheet.getCell('A2').value = `Vigencia: ${this.vigenciaActual} | Compañía: ${companyName}`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells('A3:B3');
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                const headers = ['Descripción / NIIF (IFRS)', `${this.vigenciaActual}`];
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                worksheet.columns = [
                    { width: 50 },
                    { width: 25 }
                ];

                this.listReportesComparativo.forEach(item => {
                    const row = worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_actual || 0
                    ]);
                    row.getCell(1).style = styles.datoNormal;
                    row.getCell(2).style = styles.datoNumero;
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_${companyName}_${this.vigenciaActual}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async exportarExcel() {
            if (!this.listReportesGuardados.length) return;

            this.isLoading = true;
            try {
                const workbook = new XLSX.Workbook();
                const worksheet = workbook.addWorksheet("Reportes ORI");

                const styles = {
                    tituloPrincipal: {
                        font: { name: "Calibri", size: 16, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    subtitulo: {
                        font: { name: "Calibri", size: 11, bold: true },
                        alignment: { horizontal: "center", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    encabezado: {
                        font: { name: "Calibri", size: 11, bold: true, color: { argb: "000000" } },
                        alignment: { horizontal: "center", vertical: "middle" },
                        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "E6E6E6" } },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNormal: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "left", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    },
                    datoNumero: {
                        font: { name: "Calibri", size: 10 },
                        alignment: { horizontal: "right", vertical: "middle" },
                        border: { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }
                    }
                };

                const company = this.listCompany.find(c => c.id == this.companyId);
                const companyName = company ? company.nombre : this.companyId;
                const userName = this.$store?.state?.userName || localStorage.getItem('userName') || 'Usuario';
                const reporteNombre = this.listReporte.find(r => r.codigo == this.selReporte)?.nombre || 'Reporte ORI';

                // Título principal
                worksheet.mergeCells('A1:D1');
                worksheet.getCell('A1').value = this.tituloTabla;
                Object.assign(worksheet.getCell('A1'), styles.tituloPrincipal);

                // Fila 2: Vigencia y Compañía
                worksheet.mergeCells('A2:D2');
                worksheet.getCell('A2').value = `Vigencia: ${this.selVigencia} | Compañía: ${companyName}`;
                Object.assign(worksheet.getCell('A2'), styles.subtitulo);

                // Fila 3: Generado por y Reporte
                worksheet.mergeCells('A3:D3');
                const today = new Date();
                const fechaFormateada = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
                worksheet.getCell('A3').value = `Generado: ${fechaFormateada} por ${userName} | Reporte: ${reporteNombre}`;
                Object.assign(worksheet.getCell('A3'), styles.subtitulo);

                worksheet.addRow([]);

                const headers = ['Descripción / NIIF (IFRS)', 'Local', `Funcional`, `Interna`];
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    Object.assign(cell, styles.encabezado);
                });

                worksheet.columns = [
                    { width: 50 },
                    { width: 20 },
                    { width: 20 },
                    { width: 20 }
                ];

                this.listReportesGuardados.forEach(item => {
                    const row = worksheet.addRow([
                        item.descripcion || '-',
                        item.saldo_local || 0,
                        item.saldo_funcional || 0,
                        item.saldo_interna || 0
                    ]);
                    row.getCell(1).style = styles.datoNormal;
                    row.getCell(2).style = styles.datoNumero;
                    row.getCell(3).style = styles.datoNumero;
                    row.getCell(4).style = styles.datoNumero;
                });

                worksheet.views = [{ state: 'frozen', ySplit: 5 }];

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.href = url;

                link.download = `ORI_${companyName}_${this.selVigencia}.xlsx`;

                link.click();
                URL.revokeObjectURL(url);

                this.$toast.success("Excel exportado correctamente");
            } catch (error) {
                console.error("Error exportando:", error);
                this.$toast.error("Error al exportar Excel");
            } finally {
                this.isLoading = false;
            }
        },

        async loadUserCompanies() {
            try {
                const userResult = await Balance.leaCompaniaUsuario();
                const companiaUsuario = userResult.data.companiaUsuario;

                const companiesResult = await Company.getAllCompanies();
                const allCompanies = companiesResult.data.companies;

                const filteredCompanies = allCompanies.filter((company) => {
                    if (this.$store.state.userRole == 1) return true;
                    return companiaUsuario.find(
                        (userCompany) =>
                            userCompany.id_usuario == this.$store.state.userId &&
                            userCompany.id_compania == company.id
                    );
                });

                this.listCompany = filteredCompanies;
                this.filteredCompany = filteredCompanies;
            } catch (err) {
                console.error("Error loading companies:", err);
            }
        },

        async loadVigencias() {
            try {
                const result = await PlanCuentas.getVigenciaPlancuentas();
                this.listVigencia = result.data.getVigencia;
            } catch (err) {
                console.error("Error loading vigencias:", err);
            }
        },

        async loadReportTypes() {
            try {
                const res = await TipoReporte.getAllTipoReporte();
                this.listReporte = res.data.typeReport;
            } catch (err) {
                console.error("Error loading report types:", err);
            }
        },

        async loadGrupos() {
            try {
                const result = await Grupo.getAllGrupos();
                this.listGrupos = result.data.grupos;
            } catch (err) {
                console.error("Error loading grupos:", err);
            }
        }
    },

    mounted() {
        this.isLoading = true;
        Promise.all([
            this.loadUserCompanies(),
            this.loadVigencias(),
            this.loadReportTypes(),
            this.loadGrupos()
        ]).finally(() => {
            this.isLoading = false;
        });
    }
}
</script>

<style scoped>
.balance-table {
    font-size: 14px;
}

.form-control {
    font-size: 0.9rem !important;
    padding: 0.25rem 0.5rem !important;
    height: auto !important;
}

.form-control-lg {
    font-size: 1.25rem !important;
    padding: 0.5rem 1rem !important;
    height: auto !important;
    line-height: 1.5 !important;
    border-radius: 0.3rem !important;
}

.fs-5 {
    font-size: 1.25rem !important;
}

.fs-4 {
    font-size: 1.5rem !important;
}

.w-auto {
    width: auto !important;
}

.px-3 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}

.mr-1 {
    margin-right: 0.25rem !important;
}

.balance-table>>>.md-table-head {
    padding: 12px 8px !important;
    background-color: #f8f9fa !important;
    color: #495057 !important;
    font-weight: 700 !important;
    border-bottom: 2px solid #dee2e6 !important;
    border-left: none !important;
    border-right: none !important;
}

.balance-table>>>.md-table-cell {
    padding: 10px 8px !important;
    min-width: auto !important;
    border-left: 1px solid #dee2e6 !important;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-cell:first-child {
    border-left: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-cell:last-child {
    border-right: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-row:first-child .md-table-cell {
    border-top: none !important;
}

.balance-table>>>.md-table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
}

.balance-table>>>.md-table-row {
    border-bottom: 1px solid #dee2e6 !important;
}

.balance-table>>>.md-table-toolbar {
    min-height: 60px !important;
    padding: 12px 16px !important;
    background-color: #ffffff !important;
    border-bottom: 1px solid #dee2e6 !important;
}

.principal-table>>>.md-table-cell:nth-child(1) {
    width: 400px !important;
    max-width: 400px !important;
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: unset !important;
    word-wrap: break-word !important;
    line-height: 1.2 !important;
    height: auto !important;
    min-height: 40px !important;
}

.principal-table>>>.md-table-cell:nth-child(2),
.principal-table>>>.md-table-cell:nth-child(3),
.principal-table>>>.md-table-cell:nth-child(4) {
    width: 200px !important;
    max-width: 200px !important;
}

.descripcion-cell {
    text-align: left !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

.number-cell {
    text-align: right !important;
}

.loading-spinner {
    text-align: center;
}

.text-left {
    text-align: left !important;
}

.text-center {
    text-align: center !important;
}

.btn-ingresar-valor {
    min-width: 150px;
}

/* Estilos del modal */
.valor-dialog>>>.md-dialog {
    max-width: 500px;
    width: 90%;
}

.dialog-header-create {
    background: #2e507a;
    color: white;
    padding: 15px 20px;
}

.form-container {
    padding: 20px 0;
}

.form-group {
    margin-bottom: 20px;
}

.field-label {
    display: block;
    font-weight: 600;
    margin-bottom: 8px;
    color: #2c3e50;
}

.filtro-label {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
}

.checkbox-label {
    font-weight: 400 !important;
}

input[type="checkbox"] {
    transform: scale(1.1);
    margin-right: 0.25rem;
}

.field-label.required:after {
    content: '*';
    color: #cd2838;
    margin-left: 4px;
}

.principal-table>>>.md-table-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.principal-table>>>.md-table-row:hover {
    background-color: #f0f7ff;
}

.empresas-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.empresa-checkbox {
    min-width: 200px;
    background: #f8f9fa;
    padding: 8px 12px;
    border-radius: 6px;
    margin-right: 10px !important;
}

.empresa-checkbox:hover {
    background: #e9ecef;
}

.empresa-item {
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background-color 0.2s;
}

.empresa-item:hover {
    background-color: #f0f7ff;
}

.empresa-item label {
    width: 100%;
    cursor: pointer;
    margin: 0;
}
</style>
<style src="../main.css"></style>